import { MenuIcon, XIcon } from 'lucide-react';
import React from 'react';

type Props = {
  isOpen: boolean;
  onClick: () => void;
};

export default function MobileMenuButton({ onClick, isOpen }: Props) {
  return (
    <button
      type="button"
      className="relative inline-flex items-center justify-center rounded-md p-2 text-slate-400 focus:outline-hidden"
      aria-controls="mobile-menu"
      aria-expanded="false"
      onClick={onClick}
    >
      <span className="absolute -inset-0.5"></span>
      <span className="sr-only">Open main menu</span>

      {!isOpen && <MenuIcon />}
      {isOpen && <XIcon />}
    </button>
  );
}
